import React, { useState, useEffect, useRef } from "react";
import Tickets from "./Tickets";
import moment from "moment";
import { __ } from '@wordpress/i18n';

const SingleTicket = ({ id }) => {

  const uploadref = useRef(null);
  const [singleticket, setSingleTicket] = useState({});
  const [ticketReplies, setTicketReplies] = useState([]);
  const [allticketclick, setAllTicketClick] = useState(false);
  const [loading, setLoading] = useState(true);
  const [uploadFiles, setUplaodFiles] = useState(null);
  const [replayMessage, setReplayMessage] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    const newstate = renderTest.map((elm) => {
      return elm;
    });
    setrenderTest(newstate);
  };

  const handleUploadClick = () => {
    uploadref.current.click();
  };

  Array.prototype.filterCustom = function (callback) {
    const filterdArray = [];
    for (let i = 0; i < this.length; i++) {
      callback(this[i]) ? filterdArray.push(this[i]) : null;
    }
    return filterdArray;
  };

  Array.prototype.filterForeach = function (callback) {
    let currentindex;
    for (let i = 0; i < this.length; i++) {
      if (callback(this[i])) {
        return this[i];
      }
    }
  };

  const clousreadd = () => {
    let val = 0;
    return (add = 0) => {
      val = val + add;

      return val;
    };
  };

  const handleFilesChange = (e) => {
    setUplaodFiles(e.target.files);
  };

  const handleAddReplay = async (e) => {
    setSubmitLoading(true);
    const formdata = new FormData();
    if (uploadFiles) {
      for (let i = 0; i < uploadFiles.length; i++) {
        formdata.append("files[]", uploadFiles[i]);
      }
    }

    formdata.append("action", "hive_support_add_replay_from_frontend");
    formdata.append("replaymessage", replayMessage);
    formdata.append("ticketid", Number(id));
    formdata.append("person_id", window.shortcodes_data.current_user.ID);
    const request = await fetch(
      window.hive_support_client_script_object.ajaxurl,
      {
        method: "POST",
        body: formdata,
      }
    );

    const response = await request.json();
    if (response) {
      setSubmitLoading(false);
      setReplayMessage("");
      setUplaodFiles(null);
      getticketandreplies();
    }
  };

  const uploadfiledata = [];

  const isSupportedImage = (file) => {
    const supportedImageTypes = ["jpeg", "png", "gif", "jpg", "webp"];
    return supportedImageTypes.some((type) => file.type.includes(type));
  };
  if (uploadFiles) {
    for (let i = 0; i < uploadFiles.length; i++) {
      console.log("Filename", uploadFiles[i].name);
      if (isSupportedImage(uploadFiles[i])) {
        const img = URL.createObjectURL(uploadFiles[i]);
        uploadfiledata.push({
          type: "image",
          img_src: img,
        });
      } else {
        uploadfiledata.push({
          type: "image",
          filename: uploadFiles[i].name,
        });
      }
    }
  }

  const throtling = (func, delay) => {
    let lastime = 0;
    let id = 0;

    return (...args) => {
      const now = new Date().getTime();
      id++;
      if (now - lastime < delay) return;
      lastime = now;
      console.log(`event id is ${id}`);
      func(...args);
    };
  };

  //Caching is important for memorizing datat that doiesa not often change
  const debouncing = (func, delay) => {
    let timerid;

    return () => {
      const context = this;
      const args = arguments;
      clearTimeout(timerid);
      timerid = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  };

  const TimeDiffrence = () => {
    let delaytime;
    const nowtime = new Date().getTime();
    setTimeout(() => {
      delaytime = new Date().getTime();
    }, 10000);
  };

  const clousreFunction = () => {
    let timer = 1;
    return () => {
      timer++;
      return timer;
    };
  };

  const getticketandreplies = async () => {
    const formdata = new FormData();
    formdata.append("ticketid", Number(id));
    formdata.append("action", "hive_support_get_ticket_replies");
    const request = await fetch(
      window.hive_support_client_script_object.ajaxurl,
      {
        method: "POST",
        body: formdata,
      }
    );
    const response = await request.json();
    setLoading(false);
    setSingleTicket(response.data.tickets);
    setTicketReplies(response.data.ticket_replies);
  };

  useEffect(() => {
    getticketandreplies();
  }, []);

  if (loading) {
    return (
      <div
        className="w-full h-screen flex justify-center items-center"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div class="hive_support_loader"></div>
      </div>
    );
  }
  if (allticketclick) {
    return <Tickets />;
  }
  return (
    <div id="hive_support_client_thread" style={{ display: "block" }}>
      <div className="hive_support_client_thread_header">
        {/* <h4 onClick={debouncing(() => console.log("Clicking"), 2000)}>Support Portal</h4> */}
        <h4 onClick={clousreFunction()}>{__( "Support Portal", "hive-support" )}</h4>
        <button
          className="show_tickets"
          onClick={() => setAllTicketClick(true)}
        >
        {__( "All Tickets", "hive-support" )}
        </button>
      </div>

      <div className="hive_support_client_form_body hive_support_thread_reply_form">
        <div className="hive_support_single_form_element hive_support_thread_reply_msg_field">
          <label className="hive_support_element_label">Message</label>
          <div className="hive_support_element_field_main">
            <textarea
              rows={4}
              onChange={(e) => setReplayMessage(e.target.value)}
              required=""
              value={replayMessage}
            />
          </div>
        </div>
        <div
          className="hive_support_single_form_element"
          data-field_slug="submit_btn"
        >
          <div className="flex-wrap media-upload-preview">
            {uploadfiledata && Array.isArray(uploadfiledata) &&
              uploadfiledata.map((file, index) => {
                if (file.img_src) {
                  return <img src={file.img_src} alt="" />;
                } else {
                  return <p>{__( "This is file name", "hive-support" )}</p>;
                }
                
              })}
          </div>
          <div className="ticket_media_upload" onClick={handleUploadClick}>
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.0799 10.42L9.89992 16.61C9.08973 17.33 8.03506 17.7132 6.95164 17.6814C5.86821 17.6495 4.83792 17.2048 4.07149 16.4384C3.30506 15.672 2.86043 14.6417 2.82853 13.5582C2.79664 12.4748 3.1799 11.4202 3.89992 10.61L11.8999 2.60997C12.3775 2.15627 13.0112 1.9033 13.6699 1.9033C14.3287 1.9033 14.9623 2.15627 15.4399 2.60997C15.9053 3.08156 16.1662 3.71744 16.1662 4.37997C16.1662 5.0425 15.9053 5.67838 15.4399 6.14997L8.53992 13.04C8.47163 13.1135 8.38952 13.1729 8.29829 13.2147C8.20706 13.2565 8.10849 13.2799 8.0082 13.2836C7.90791 13.2874 7.80788 13.2713 7.7138 13.2363C7.61973 13.2014 7.53346 13.1483 7.45992 13.08C7.38638 13.0117 7.32701 12.9296 7.2852 12.8383C7.24339 12.7471 7.21995 12.6485 7.21624 12.5483C7.21253 12.448 7.2286 12.3479 7.26355 12.2539C7.29849 12.1598 7.35163 12.0735 7.41992 12L12.5499 6.87997C12.7382 6.69166 12.844 6.43627 12.844 6.16997C12.844 5.90367 12.7382 5.64827 12.5499 5.45997C12.3616 5.27166 12.1062 5.16588 11.8399 5.16588C11.5736 5.16588 11.3182 5.27166 11.1299 5.45997L5.99992 10.6C5.74322 10.8547 5.53948 11.1577 5.40045 11.4915C5.26141 11.8253 5.18983 12.1834 5.18983 12.545C5.18983 12.9066 5.26141 13.2646 5.40045 13.5984C5.53948 13.9323 5.74322 14.2353 5.99992 14.49C6.52429 14.9895 7.22072 15.2681 7.94492 15.2681C8.66911 15.2681 9.36554 14.9895 9.88992 14.49L16.7799 7.58997C17.5748 6.73692 18.0075 5.60864 17.987 4.44283C17.9664 3.27703 17.4941 2.16472 16.6696 1.34024C15.8452 0.515759 14.7329 0.0434872 13.5671 0.0229179C12.4012 0.00234858 11.273 0.435088 10.4199 1.22997L2.41992 9.22997C1.34111 10.4248 0.764944 11.9898 0.811449 13.5989C0.857954 15.2081 1.52355 16.7372 2.66955 17.8677C3.81556 18.9983 5.35359 19.643 6.9632 19.6677C8.57281 19.6923 10.1299 19.0949 11.3099 18L17.4999 11.82C17.5932 11.7267 17.6671 11.616 17.7176 11.4942C17.768 11.3724 17.794 11.2418 17.794 11.11C17.794 10.9781 17.768 10.8475 17.7176 10.7257C17.6671 10.6039 17.5932 10.4932 17.4999 10.4C17.4067 10.3067 17.296 10.2328 17.1742 10.1823C17.0523 10.1318 16.9218 10.1059 16.7899 10.1059C16.6581 10.1059 16.5275 10.1318 16.4057 10.1823C16.2838 10.2328 16.1732 10.3067 16.0799 10.4V10.42Z"
                fill="#1F8FEB"
              />
            </svg>

            <p className="upload_text">
              {__( "Drag and drop or Click here to upload file", "hive-support" )}
            </p>
            <input
              ref={uploadref}
              type="file"
              style={{ display: "none" }}
              onChange={handleFilesChange}
              multiple="multiple"
            />
          </div>
          <div className="custom_btn_container" style={{ marginTop: "20px" }}>
            {/* <button
                            className="reply_close btn-extra-style"

                        >
                            Reply &amp; Close
                        </button> */}
            <button className="reply btn-extra-style" onClick={handleAddReplay}>
              {submitLoading ? <div class="submitting_loader"></div> : __( "Reply", "hive-support" )}
            </button>
          </div>
        </div>
      </div>
      <div className="hive_support_client_thread_items">
        {ticketReplies && Array.isArray(ticketReplies) &&
          ticketReplies.map((reply, index) => (
            
            <div className="hive_support_client_thread_item ok" key={index}>
              <div className="hive_support_client_thread_item_header">
                <img src="http://1.gravatar.com/avatar/1aedb8d9dc4751e229a335e371db8058?s=96&d=mm&r=g" />
                <div className="hive_support_client_thread_item_header_details">
                  <a href="#">{reply.useobject.data.display_name}</a>
                  <span
                    className={`response_by prio-response ${
                      window.shortcodes_data.current_user.ID ==
                      reply.useobject.ID
                        ? "hs-my--message"
                        : ""
                    }`}
                  >
                    {window.shortcodes_data.current_user.ID ==
                    reply.useobject.ID
                      ? __( "You", "hive-support" )
                      : reply.user_role == "administrator"
                      ? __( "Admin", "hive-support" )
                      : reply.user_role == "hive_support_staff"
                      ?  __( "Agent", "hive-support" )
                      : __( "Customer", "hive-support" ) }
                  </span>
                  <span className="response_at">
                    {moment(reply.created_at).fromNow()}
                  </span>
                </div>
              </div>
              <div className="hive_support_client_thread_item_body">
                {/* Properly sanitize/escape HTML */}
                {/* <p>{reply.content} </p> */}
                <p dangerouslySetInnerHTML={{ __html: reply.content }}></p>
              </div>
              <div className="reply_thraed_uploaded_files">
                {reply.media_urls && Array.isArray(JSON.parse(reply.media_urls)) &&
                  JSON.parse(reply.media_urls).map((media, index) => (
                    <div className="button_file_item" key={index}>
                      {media.filepath.split(".").filter(Boolean).pop() ==
                        "jpg" ||
                      media.filepath.split(".").filter(Boolean).pop() ==
                        "jpeg" ||
                      media.filepath.split(".").filter(Boolean).pop() ==
                        "png" ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.1645 19.9977 17.3284 19.981 17.49 19.95L17.79 19.88H17.86H17.91L18.28 19.74L18.41 19.67C18.51 19.61 18.62 19.56 18.72 19.49C18.8535 19.3918 18.9805 19.2849 19.1 19.17L19.17 19.08C19.2682 18.9805 19.3585 18.8735 19.44 18.76L19.53 18.63C19.5998 18.5187 19.6601 18.4016 19.71 18.28C19.7374 18.232 19.7609 18.1818 19.78 18.13C19.83 18.01 19.86 17.88 19.9 17.75V17.6C19.9567 17.4046 19.9903 17.2032 20 17V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM3 18C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V12.69L5.29 9.39C5.38296 9.29627 5.49356 9.22188 5.61542 9.17111C5.73728 9.12034 5.86799 9.0942 6 9.0942C6.13201 9.0942 6.26272 9.12034 6.38458 9.17111C6.50644 9.22188 6.61704 9.29627 6.71 9.39L15.31 18H3ZM18 17C17.9991 17.1233 17.9753 17.2453 17.93 17.36C17.9071 17.4087 17.8804 17.4556 17.85 17.5C17.8232 17.5423 17.7931 17.5825 17.76 17.62L12.41 12.27L13.29 11.39C13.383 11.2963 13.4936 11.2219 13.6154 11.1711C13.7373 11.1203 13.868 11.0942 14 11.0942C14.132 11.0942 14.2627 11.1203 14.3846 11.1711C14.5064 11.2219 14.617 11.2963 14.71 11.39V11.39L18 14.69V17ZM18 11.86L16.12 10C15.5477 9.45699 14.7889 9.15428 14 9.15428C13.2111 9.15428 12.4523 9.45699 11.88 10L11 10.88L8.12 8C7.54772 7.45699 6.7889 7.15428 6 7.15428C5.2111 7.15428 4.45228 7.45699 3.88 8L2 9.86V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V11.86Z"
                            fill="#1F8FEB"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="16"
                          height="20"
                          viewBox="0 0 16 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5 8H6C6.26522 8 6.51957 7.89464 6.70711 7.70711C6.89464 7.51957 7 7.26522 7 7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8V8ZM5 10C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10H5ZM16 6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3V6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11C9.44015 0.10576 9.40985 0.10576 9.38 0.11C9.27841 0.0517412 9.16622 0.0143442 9.05 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V7C16 7 16 7 16 6.94ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V17ZM11 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H11C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15C12 14.7348 11.8946 14.4804 11.7071 14.2929C11.5196 14.1054 11.2652 14 11 14Z"
                            fill="#1F8FEB"
                          />
                        </svg>
                      )}

                      <a
                        href={media.filepath}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {media.filename}
                      </a>
                    </div>
                  ))}
              </div>
              {/*                                 
                                <div className='button_file_item'>
                                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 8H6C6.26522 8 6.51957 7.89464 6.70711 7.70711C6.89464 7.51957 7 7.26522 7 7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8ZM5 10C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10H5ZM16 6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11C9.44015 0.10576 9.40985 0.10576 9.38 0.11C9.27841 0.0517412 9.16622 0.0143442 9.05 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V7C16 7 16 7 16 6.94ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V17ZM11 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H11C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15C12 14.7348 11.8946 14.4804 11.7071 14.2929C11.5196 14.1054 11.2652 14 11 14Z" fill="#1F8FEB" />
                                    </svg>
                                    <a href="">Project One</a>
                                </div> */}
            </div>
          ))}
      </div>

      <div className="hive_support_client_thread_item">
        <div className="hive_support_client_thread_item_header">
          <img src="http://1.gravatar.com/avatar/1aedb8d9dc4751e229a335e371db8058?s=96&d=mm&r=g" />
          <div className="hive_support_client_thread_item_header_details">
            <a href="#">{singleticket.customer_name}</a>
            <span className="response_by hs-my--message">{__( "You", "hive-support" )}</span>
            <span className="response_at">
              {moment(singleticket.created_at).fromNow()}
            </span>
          </div>
        </div>
        <div className="hive_support_client_thread_item_body">
          {console.log("from view", singleticket.title)}
          <div>
            <p class="hs-ticket-content-title">{__( "Subject", "hive-support" )}</p>
            <p class="hs-ticket-content-value">{singleticket.title}</p>
          </div>
          <div>
            <p class="hs-ticket-content-title">{__( "Message", "hive-support" )}</p>
            <p class="hs-ticket-content-value">{singleticket.content}</p>
          </div>
          {singleticket.ticket_fields && Array.isArray(JSON.parse(singleticket.ticket_fields)) &&
            JSON.parse(singleticket.ticket_fields).map((field) => (
              <div>
                <p class="hs-ticket-content-title">{field.label}</p>

                <p class="hs-ticket-content-value">{field.value}</p>
              </div>
            ))}

          <div className="reply_thraed_uploaded_files">
            {singleticket.media_urls && Array.isArray(JSON.parse(singleticket.media_urls)) &&
              JSON.parse(singleticket.media_urls).map((media, index) => (
                <div className="button_file_item" key={index}>
                  {media.filepath.split(".").filter(Boolean).pop() == "jpg" ||
                  media.filepath.split(".").filter(Boolean).pop() == "jpeg" ||
                  media.filepath.split(".").filter(Boolean).pop() == "png" ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.1645 19.9977 17.3284 19.981 17.49 19.95L17.79 19.88H17.86H17.91L18.28 19.74L18.41 19.67C18.51 19.61 18.62 19.56 18.72 19.49C18.8535 19.3918 18.9805 19.2849 19.1 19.17L19.17 19.08C19.2682 18.9805 19.3585 18.8735 19.44 18.76L19.53 18.63C19.5998 18.5187 19.6601 18.4016 19.71 18.28C19.7374 18.232 19.7609 18.1818 19.78 18.13C19.83 18.01 19.86 17.88 19.9 17.75V17.6C19.9567 17.4046 19.9903 17.2032 20 17V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM3 18C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V12.69L5.29 9.39C5.38296 9.29627 5.49356 9.22188 5.61542 9.17111C5.73728 9.12034 5.86799 9.0942 6 9.0942C6.13201 9.0942 6.26272 9.12034 6.38458 9.17111C6.50644 9.22188 6.61704 9.29627 6.71 9.39L15.31 18H3ZM18 17C17.9991 17.1233 17.9753 17.2453 17.93 17.36C17.9071 17.4087 17.8804 17.4556 17.85 17.5C17.8232 17.5423 17.7931 17.5825 17.76 17.62L12.41 12.27L13.29 11.39C13.383 11.2963 13.4936 11.2219 13.6154 11.1711C13.7373 11.1203 13.868 11.0942 14 11.0942C14.132 11.0942 14.2627 11.1203 14.3846 11.1711C14.5064 11.2219 14.617 11.2963 14.71 11.39V11.39L18 14.69V17ZM18 11.86L16.12 10C15.5477 9.45699 14.7889 9.15428 14 9.15428C13.2111 9.15428 12.4523 9.45699 11.88 10L11 10.88L8.12 8C7.54772 7.45699 6.7889 7.15428 6 7.15428C5.2111 7.15428 4.45228 7.45699 3.88 8L2 9.86V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V11.86Z"
                        fill="#1F8FEB"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="16"
                      height="20"
                      viewBox="0 0 16 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 8H6C6.26522 8 6.51957 7.89464 6.70711 7.70711C6.89464 7.51957 7 7.26522 7 7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8V8ZM5 10C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10H5ZM16 6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3V6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11C9.44015 0.10576 9.40985 0.10576 9.38 0.11C9.27841 0.0517412 9.16622 0.0143442 9.05 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V7C16 7 16 7 16 6.94ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V17ZM11 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H11C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15C12 14.7348 11.8946 14.4804 11.7071 14.2929C11.5196 14.1054 11.2652 14 11 14Z"
                        fill="#1F8FEB"
                      />
                    </svg>
                  )}

                  <a
                    href={media.filepath}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {media.filename}
                  </a>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleTicket;
